<template src='./headerBar.pug' lang='pug'></template>

<script>
export default {
  name: 'HeaderBar',

  props: [
    'title',
    'subTitle'
  ]
}
</script>

<style scoped>
.headerBar-title-wrapper {
  font-family: 'Inter', sans-serif;
  margin-bottom: 15px;
  border-bottom: 1px solid #d0d0d0;
}

h1.primary-title {
  font-size: 2em;
  font-family: 'Inter', sans-serif;
font-weight: 700;
  color: transparent;
}

h4.subtitle-headerBar {
  margin-top: 23px;
  color: #1d436a;
}

.fields-wrapper {
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// HeaderBar.vue?029f9374